import {
  QueryHookOptions,
  QueryResult,
  SuspenseQueryHookOptions,
  UseSuspenseQueryResult,
} from '@apollo/client';

type QueryVariables = {
  filter?: string | null;
  pageSize?: number | null;
  pageToken?: string | null;
  orderBy?: string | null;
};

// Overload for regular hooks
export function withRequiredVariables<
  TData extends Record<string, unknown>,
  TRequiredVars extends Record<string, unknown>,
>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- useQuery accepts Apollo-generated hooks with overloaded signatures; unknown[] is contravariantly stricter and rejects them
  useQuery: (...args: any[]) => QueryResult<TData, TRequiredVars>,
): (
  options?: QueryHookOptions<TData, QueryVariables & TRequiredVars>,
) => QueryResult<TData, QueryVariables & TRequiredVars>;

// Overload for suspense hooks
export function withRequiredVariables<
  TData extends Record<string, unknown>,
  TRequiredVars extends Record<string, unknown>,
>(
  useQuery: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- useQuery accepts Apollo-generated hooks with overloaded signatures; unknown[] is contravariantly stricter and rejects them
    ...args: any[]
  ) => UseSuspenseQueryResult<TData | undefined, TRequiredVars>,
): (
  options?: SuspenseQueryHookOptions<
    TData | undefined,
    QueryVariables & TRequiredVars
  >,
) => UseSuspenseQueryResult<TData | undefined, QueryVariables & TRequiredVars>;

// Implementation
export function withRequiredVariables(
  useQuery: (options?: Record<string, unknown>) => unknown,
) {
  return (options?: Record<string, unknown>) => {
    return useQuery({
      ...options,
      variables: options?.variables as Record<string, unknown> | undefined,
    });
  };
}
